<template>
  <div class="sensorManagement-page" v-allow="'080201'" style="width: 100%">
    <div class="all-content-container">
      <div class="table-content-container">
        <div class="table-title-container">
          <div class="table-title-title">
            <h4>传感器</h4>
            <div>
              <el-button type="primary" class="addBtn" @click="add">添加</el-button>
              <el-button type="primary" class="addBtn" @click="handlePosition()">设备位置配置</el-button>
            </div>
          </div>
          <div class="table-content-title">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="设备名称：">
                <el-input v-model="name" placeholder="请输入设备名称" clearable maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="设备编码：">
                <el-input v-model="code" placeholder="请输入设备编码" clearable maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="所属分组：">
                <el-cascader @change="changeTreeItem" :show-all-levels="false" v-model="groupId" :options="departList" :props="optionProps" clearable placeholder="请选择所属分组"></el-cascader>
              </el-form-item>
              <el-form-item class="mar-l">
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button @click="resetOnSubmit">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content">
          <div class="table-table">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#f4f5f7' }">
              <el-table-column align="center" label="序号" width="95">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="设备名称" align="center" width="250px"></el-table-column>
              <el-table-column prop="code" label="设备编码" align="center" width="250px"> </el-table-column>
              <el-table-column prop="groupName" label="所属分组" align="center"></el-table-column>
              <el-table-column prop="gatewayName" label="所属网关" align="center" width="220px"></el-table-column>
              <el-table-column prop="paramType" label="参数类型" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.paramType == 0">环境参数</span>
                  <span v-if="scope.row.paramType == 1">作物参数</span>
                  <span v-if="scope.row.paramType == 2">土壤参数</span>
                </template>
              </el-table-column>
              <el-table-column prop="intervalTime" label="采集间隔时间" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.intervalTime | intervalTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="isOpen" label="工作状态" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.isOpen == 0">
                    <span class="show-line show-rline"></span>
                    已停用
                  </div>
                  <div v-if="scope.row.isOpen == 1">
                    <span class="show-line show-bline"></span>
                    已启用
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="360px">
                <template slot-scope="scope">
                  <el-button type="text" :underline="false" size="small" class="marginLr" @click="edit(scope.row.id)">编辑</el-button>
                  <el-button type="text" :underline="false" size="small" class="marginLr" @click="dele(scope.row.id)">删除</el-button>
                  <el-button type="text" :underline="false" size="small" class="marginLr" v-if="scope.row.isOpen == 1" @click="onOrOffNumericalBth1(scope.row.id)">停用</el-button>
                  <el-button type="text" :underline="false" size="small" class="marginLr" v-if="scope.row.isOpen == 0" @click="onOrOffNumericalBth(scope.row.id)">启用</el-button>
                  <el-button type="text" :underline="false" size="small" class="marginLr" @click="getSetDataHisDataList(scope.row)">设备数据</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-content-container" style="float: right; margin-top: 10px">
              <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" :total="total"></el-pagination>
            </div>
            <!--点击设备数据弹出层-->
            <el-dialog title="设备数据" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose">
              <el-radio-group v-model="tabPosition" style="margin-top: -20px; margin-bottom: 10px; margin-right: 20px; margin-bottom: 20px">
                <el-radio-button label="图表" style="height: 30px"></el-radio-button>
                <el-radio-button label="列表" style="height: 30px"></el-radio-button>
              </el-radio-group>
              <div style="display: block; float: right; margin-top: -35px; margin-right: 20px">
                <br />属性名称：
                <el-select v-model="value" placeholder="请选择" @change="searchDataHisData()">
                  <el-option v-for="item in options" :key="item.id" :label="item.cname" :value="item.id"></el-option> </el-select
                >&#x3000; 日期： <el-select v-model="value2" placeholder="请选择" @change="searchDataHisData()"> <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option> </el-select>&#x3000;
                <el-date-picker v-if="value2 == '999'" v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 260px" @change="changeOneTime" :picker-options="pickerOptions0" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>&#x3000;
                <el-button @click="searchDataHisData()" type="primary">查询</el-button>
              </div>
              <div v-if="tabPosition == '列表'">
                <el-table border :data="tableData1" style="width: 100%; height: 464px">
                  <el-table-column align="center" prop="deviceName" label="设备名称"></el-table-column>
                  <el-table-column align="center" prop="attributeName" label="属性名称"></el-table-column>
                  <el-table-column align="center" prop="value" label="数值"></el-table-column>
                  <el-table-column align="center" prop="createDate" label="平台数据接收时间">
                    <template slot-scope="scope">
                      <span>{{ scope.row.createDate | zhDatetime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="selectDate" label="平台指令下发时间">
                    <template slot-scope="scope">
                      <span>{{ scope.row.selectDate | zhDatetime }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="averageResponseTime" label="平均响应时间"></el-table-column>
                </el-table>
                <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange2" :current-page="currentPage4" :page-size="pageSize1" :total="total2" style="float: right; margin-top: 10px"></el-pagination>
              </div>
              <div v-else-if="tabPosition == '图表'">
                <div id="mainOne" style="width: 100%; height: 500px; display: inline-block"></div>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import echarts from 'echarts'

export default {
  name: 'sensorManagement',
  data() {
    return {
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6 //如果没有后面的-8.64e6就是不可以选择今天的
        }
      },
      tubiaoList: [],
      biaogeList: [],
      total: 0,
      sid: '',
      options: [],
      value: '',
      options1: [
        {
          value: '0',
          label: '一小时内'
        },
        {
          value: '1',
          label: '一天内'
        },
        {
          value: '2',
          label: '一周内'
        },
        {
          value: '3',
          label: '一月内'
        },
        {
          value: '999',
          label: '自定义时间'
        }
      ],
      value1: '',
      value2: '0',
      pageSize1: 8,
      currentPage4: 1,
      tableData1: [],
      tabPosition: '图表',
      activeName: 'first',
      dialogVisible: false,
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true
      },
      input: '',
      input1: '',
      input2: '',
      total2: 0,
      tableData: [],
      currentPage: 1,
      pagesize: 8,
      code: '',
      groupId: '',
      name: '',
      departList: [],
      getGatewaysList: [],
      timeType: 1,
      begDate: '',
      endDate: ''
    }
  },
  created() {
    this.init()
  },
  watch: {
    tabPosition(val) {
      this.searchDataHisData()
    }
  },
  methods: {
    zhDatetime(t) {
      if (t == '' || t == null || t == undefined) {
        return ''
      } else {
        var d = new Date(t)
        // d.setTime(t);
        var Y = d.getFullYear()
        var M = d.getMonth() + 1
        var D = d.getDate()
        var h = d.getHours()
        var m = d.getMinutes()
        var s = d.getSeconds()
        M = M > 9 ? M : '0' + M
        D = D > 9 ? D : '0' + D
        h = h > 9 ? h : '0' + h
        m = m > 9 ? m : '0' + m
        s = s > 9 ? s : '0' + s
        return h + ':' + m + ':' + s
      }
    },
    // 时间格式化，年月日时分秒
    zhDatetime1(t) {
      if (t == '' || t == null || t == undefined) {
        return ''
      } else {
        var d = new Date(t)
        var Y = d.getFullYear()
        var M = d.getMonth() + 1
        var D = d.getDate()
        var h = d.getHours()
        var m = d.getMinutes()
        var s = d.getSeconds()
        M = M > 9 ? M : '0' + M
        D = D > 9 ? D : '0' + D
        h = h > 9 ? h : '0' + h
        m = m > 9 ? m : '0' + m
        s = s > 9 ? s : '0' + s
        return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s
      }
    },
    // 时间改变
    changeOneTime(val) {
      if (val && val.length == 2) {
        this.begDate = val[0] + ' 00:00:00'
        this.endDate = val[1] + ' 23:00:00'
        // 查询历史数据
        this.searchDataHisData()
      }
    },
    // 查询历史数据
    searchDataHisData() {
      if (this.value2 == '999' && this.value1 == '') {
        // 自定义时间段
        this.$message.error('请选择开始时间、结束时间')
        return
      }

      if (this.tabPosition == '图表') {
        this.getDataHisDataChart()
      } else {
        this.getSetDataHisDataListLook()
      }
    },
    // 获取历史数据图图表
    getDataHisDataChart() {
      if (this.value2 == '999') {
        //自定义时间段
        var begDate = this.begDate
        var endDate = this.endDate
        var datatype = undefined
      } else {
        var begDate = undefined
        var endDate = undefined
        var datatype = this.value2
      }
      this.$api.system.getDataHisDataChart(this.value, this.sid, begDate, endDate, datatype).then(res => {
        if (res.code == 200) {
          this.tubiaoList = res.data
          let x = []
          let y = []
          let z = []
          var arr = []
          var obj = {}
          for (var i = 0; i < res.data.xTimes.length; i++) {
            x.push(this.zhDatetime1(res.data.xTimes[i]))
          }
          for (var j = 0; j < res.data.yDatas.length; j++) {
            arr.push(res.data.yDatas[j].value)
          }
          obj.type = 'line'
          obj.data = arr
          obj.symbol = 'none'
          obj.smooth = true
          obj.lineStyle = { color: '#0356fe' }
          obj.areaStyle = {
            normal: {
              color: 'rgba(3,86,254,.3)' //改变区域颜色
            }
          }

          y.push(obj)
          z.push(this.attributeName)
          this.initChart(x, y, z)
        } else {
          this.loading = false //关闭加载
          this.$meessage.error(res.msg)
        }
      })
    },
    initChart(x, y, z) {
      var myChart = document.getElementById('mainOne')
      var chartObj = echarts.init(myChart)
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },

        color: ['#0356fe'],
        legend: {
          data: z,
          textStyle: {
            //图例文字的样式
            color: '#6a7985',
            fontSize: 14
          },
          x: 'center', //可设定图例在左、右、居中
          y: 'bottom'
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            showMaxLabel: true
          },
          data: x,
          splitLine: {
            show: false,
            lineStyle: {
              color: ['#ccc'],
              width: 1,
              type: 'solid'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#333',
              width: 1 //这里是为了突出显示加上的
            }
          },
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
            lineStyle: {
              color: ['#ccc'],
              width: 1,
              type: 'solid'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#333',
              width: 1 //这里是为了突出显示加上的
            }
          },
          boundaryGap: false
          // inverse: true
        },
        series: y,
        grid: {
          x: 30,
          x2: 20,
          y: 20,
          left: '10%',
          right: '10%'
        }
      }
      chartObj.setOption(option)
    },
    handleSizeChange(val) {
      this.pageSize1 = val
      this.getSetDataHisDataListLook()
    },
    handleCurrentChange2(val) {
      this.currentPage4 = val
      this.getSetDataHisDataListLook()
    },
    // 获取历史数据列表
    getSetDataHisDataListLook(data) {
      if (this.value2 == '999') {
        //自定义时间段
        var begDate = this.begDate
        var endDate = this.endDate
        var datatype = undefined
      } else {
        var begDate = undefined
        var endDate = undefined
        var datatype = this.value2
      }

      this.$api.system.getDataHisDataList(begDate, endDate, this.value, datatype, this.sid, this.currentPage4, this.pageSize1).then(res => {
        if (res.code == 200) {
          this.total2 = res.pageInfo.total
          this.tableData1 = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 设备数据
    getSetDataHisDataList(data) {
      this.sid = data.id
      this.dialogVisible = true
      this.$api.system.getModelRuleAttributes1(data.id).then(res => {
        if (res.code == 200) {
          this.options = res.data
          this.value = res.data[0].id
          this.searchDataHisData()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    handleClose(done) {
      done()
    },
    //查询
    onSubmit() {
      this.getNumericalList()
    },
    // 重置
    resetOnSubmit() {
      this.empty()
      this.onSubmit()
    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage //第几页，默认1
      this.getNumericalList()
    },
    //清空
    empty() {
      this.name = ''
      this.code = ''
      this.groupId = '' // 分组id
    },
    //删除
    dele(id) {
      this.$confirm('是否删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.system.delfun(`/pc/objDeviceNumerical/delNumerical`, id).then(res => {
            if (res.code == 200) {
              this.getNumericalList()
              this.$message({
                type: 'success',
                message: res.msg
              })
            } else {
              // this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    //启用/停用 按钮
    onOrOffNumericalBth(id) {
      this.$confirm('是否启用？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.onOrOffNumerical(id)
        })
        .catch(() => {
          this.$message.info('已取消启用')
        })

      // this.onOrOffNumerical(id)
    },
    onOrOffNumericalBth1(id) {
      this.$confirm('是否停用？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.onOrOffNumerical(id)
        })
        .catch(() => {
          this.$message.info('已取消停用')
        })

      // this.onOrOffNumerical(id)
    },
    //启用/停用
    onOrOffNumerical(id) {
      this.$api.system
        .onOrOffNumerical(id)
        .then(res => {
          if (res.code == 200) {
            this.getNumericalList()
            this.$message({
              type: 'success',
              message: res.msg
            })
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    // 编辑
    edit(id) {
      this.$router.push({
        path: 'addSensorManagement',
        query: {
          id: id
        }
      })
    },
    //添加
    add() {
      this.$router.push({
        path: 'addSensorManagement',
        query: {}
      })
    },
    changeTreeItem(val) {
      this.groupId = val[val.length - 1]
    },
    init() {
      this.getNumericalList()
      this.getConfigGroupTree()
    },
    // 查询传感器列表
    getNumericalList() {
      this.$api.system
        .getNumericalList(
          this.currentPage, //第几页，默认1
          this.pagesize, //默认展示多少条，默认10
          this.code, //设备编码
          this.groupId, // 分组id
          this.name //名称
        )
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data
            this.total = res.count
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    //查询设备分组树，查询1
    getConfigGroupTree() {
      this.$api.system
        .getConfigGroupTree(
          0 //主键id ，根据具体业务进行判定
        )
        .then(res => {
          if (res.code == 200) {
            this.departList = res.data
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    // 设备位置配置
    handlePosition() {
      this.$router.push({
        name: `deviceGroupPosition`,
        query: {}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/sensorManagement.scss';

li {
  padding-left: 15px;
}
</style>
